import { useEffect, useRef, useState } from "react";

/**
 * Open/close state for a field's popover (DateField, SelectMenu): closes on
 * a click outside `ref` or on Escape, the way the work order list's calendar
 * does. `openUp` flips the popover above the field when there isn't room
 * below it — the order form's lower cards sit near the bottom of the window.
 */
export default function usePopover(popHeight) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  function show() {
    if (ref.current) {
      const box = ref.current.getBoundingClientRect();
      const below = window.innerHeight - box.bottom;
      setOpenUp(below < popHeight + 16 && box.top > below);
    }
    setOpen(true);
  }

  return { ref, open, openUp, show, hide: () => setOpen(false) };
}
